<template>
    <card>
        <card-header>
            <card-overline>Liefermahnung</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>P-Nr.</th>
                    <th>Ausgangsdatum</th>
                    <th>Frist bis (neuer Liefertermin)</th>
                    <th>Kommentar</th>
                    <th>Operator</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="reminder in reminders" :key="reminder.index">
                    <td>{{ this.askForQuote.pfnumber }}</td>
                    <td>{{ reminder.created_at_string }}</td>
                    <td>{{ reminder.corrected_delivery_date_string }}</td>
                    <td>{{ reminder.comment }}</td>
                    <td>{{ reminder?.admin_user?.name }}</td>
                    <td class="small">
                        <form-button icon="document-file-eye" dense="true"
                                     @click="viewReminderModal = true; showReminder = reminder"/>
                        <form-button type="button" dense="true"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.delivery.reminder.delete', {'askForQuote': this.askForQuote, 'reminder': reminder.id})"
                                     icon="trash-delete-bin-2" v-if="!infoOnly"/>
                    </td>
                </tr>
                </tbody>
            </table>

            <modal-dialog title="Liefermahnung löschen" text="Möchten Sie die Liefermahnung wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>

            <modal v-if="viewReminderModal" width="small">
                <modal-header>
                    Bestätigungsmahnung
                </modal-header>
                <modal-content>
                    <description-group grid="grid">
                        <description-element :caption="showReminder.created_at" title="Ausgangsdatum" is-date="true"/>
                        <description-element :caption="showReminder.corrected_delivery_date"
                                             title="Frist bis (neuer Liefertermin)" is-date="true"/>
                        <description-element :caption="showReminder.admin_user.name" title="Operator"/>
                    </description-group>
                    <hr v-if="showReminder.comment">
                    <span class="caption" v-if="showReminder.comment">
                                                        Kommentar
                                                    </span>
                    <p v-if="showReminder.comment">{{ showReminder.comment }}</p>
                    <hr>
                    <div v-html="showReminder.text"/>
                </modal-content>
                <modal-actions @closeDialog="viewReminderModal = false; showReminder = null;"/>
            </modal>
        </card-content>
        <card-content v-if="!infoOnly">
            <form-button class="btn--block" color="secondary" @click="producerOrderDeliveryReminderModal = true;"
                         :disabled="!producerOrder" icon="calendar-add-circle">neue Liefermahnung
            </form-button>

            <producer-order-delivery-reminder-modal :ask-for-quote="askForQuote"
                                                    v-if="producerOrderDeliveryReminderModal"
                                                    @closeDialog="producerOrderDeliveryReminderModal = false;"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ProducerOrderDeliveryReminderModal
    from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerOrderDeliveryReminderModal';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import Modal from '@partfactory/Shared/Modal/Modal';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';

export default {
    name: 'ProducerOrderDeliveryReminder',
    components: {
        ModalDialog,
        DescriptionGroup,
        DescriptionElement,
        Modal,
        ModalHeader,
        ModalActions,
        ModalContent, ProducerOrderDeliveryReminderModal, FormButton, CardContent, CardOverline, CardHeader, Card
    },
    props: {
        askForQuote: Object,
        infoOnly: Boolean,
    },
    data() {
        return {
            producerOrderDeliveryReminderModal: false,
            viewReminderModal: false,
            showReminder: null,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        reminders() {
            return this.askForQuote?.reminders?.map(reminder => {
                reminder.created_at_string = this.$date(reminder.created_at);
                reminder.corrected_delivery_date_string = this.$date(reminder.corrected_delivery_date);
                return reminder;
            });
        },
        producerOrder() {
            return this.askForQuote?.producer_order;
        }
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
